import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  radioButton: {
    height: 15,
    '&:checked': {
      color: theme.palette.primary.main,
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  label: {
    alignItems: 'center',
  },
  checked: {
    color: theme.palette.primary.main,
  },
}));
